"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const ArrowDown = ({ size = 16, fill, name = "Arrow down", ...rest }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Base_1.Base, { smooth: true, size: size, fill: fill !== null && fill !== void 0 ? fill : theme.icon, ...rest },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M4,7h8l-4,7Z" })));
};
exports.default = ArrowDown;
//# sourceMappingURL=index.js.map